import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CloseIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M17 1L1 17M1 1l16 16"
        stroke={tintColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default CloseIcon;
